<template>
    <div class="search-list">
        <PageHeaderResult></PageHeaderResult>
        <!-- {{ this.$store.state.currentSearchKeyword }} -->
        <ul class="book-cards">
            <!-- <li v-for="(item, index) in books" :key="index">{{ item.title }}</li> -->
            <BooksCard v-for="(item, index) in books" :key="index" :item="item"></BooksCard>
        </ul>
        <van-loading type="spinner" color="#B83320" v-if="loading" />
    </div>
</template>

<script>
import Vue from "vue";
import PageHeaderResult from "@/components/PageHeaderResult.vue";
import BooksCard from "@/components/BooksCard.vue";

export default {
    components: {
        PageHeaderResult,
        BooksCard
    },
    data() {
        return {
            books: null,
            loading: false
        };
    },
    methods: {},
    // 方法一：导航完成之后获取
    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         // 通过 `vm` 访问组件实例
    //         vm.axios
    //             .get("https://novel.kele8.cn/search", {
    //                 params: {
    //                     keyword: to.query.keyword
    //                 }
    //             })
    //             .then(response => {
    //                 vm.books = response.data.books;
    //                 window.console.log(response.data);
    //             });
    //     });
    // }
    // 方法二：导航完成之前获取 (better)
    beforeRouteEnter(to, from, next) {
        // 通过 `vm` 访问组件实例
        Vue.axios
            .get("https://novel.kele8.cn/search", {
                params: {
                    keyword: to.query.keyword
                }
            })
            .then(response => {
                next(vm => {
                    vm.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });
                    vm.books = response.data.books;
                    // window.console.log(response.data);
                });
            })
            .finally(this.$toast.clear());
    }
};
</script>

<style lang="less">
.search-list {
    background: rgb(245, 242, 237);
    ul.book-cards {
        margin-bottom: 50px;
        li {
        }
    }
}
</style>
